(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1632],{

/***/ 48456:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ Home; }
});

// EXTERNAL MODULE: ./components/common/Layout/index.js + 26 modules
var Layout = __webpack_require__(19738);
// EXTERNAL MODULE: ./components/templates/offshore/articles/index.js
var articles = __webpack_require__(85244);
;// CONCATENATED MODULE: ./pages/offshore/articles/data.json
var data_namespaceObject = JSON.parse('{"banner":{"title":"Articles","description":"Discover our selection of articles, insights, and resources for running a successful business in offshore countries.","breadcrumbs":[{"title":"Home","uri":"/"},{"title":"Articles"}],"image":{"src":"/assets/images/offshore/articles/banner-offshore-articles.png","width":559,"height":474}},"searchBar":true,"dropdownData":{"type":"categories","data":[{"label":"All","value":"all"},{"label":"Anguilla","value":"Anguilla","icon":"ai"},{"label":"Bahamas","value":"Bahamas","icon":"bs"},{"label":"Belize","value":"Belize","icon":"bz"},{"label":"British Virgin Islands","value":"BVI","icon":"vg"},{"label":"Cayman Islands","value":"Cayman Islands","icon":"ky"},{"label":"Delaware","value":"Delaware","icon":"us"},{"label":"Panama","value":"Panama","icon":"pa"},{"label":"St. Kitts & Nevis","value":"St. Kitts & Nevis","icon":"kn"},{"label":"St. Vincent & Grenadines","value":"St. Vincent & Grenadines","icon":"vc"},{"label":"Marshall Islands","value":"Marshall Islands","icon":"mh"},{"label":"Samoa","value":"Samoa","icon":"ws"},{"label":"Cyprus","value":"Cyprus","icon":"cy"},{"label":"Mauritius","value":"Mauritius","icon":"mu"},{"label":"Seychelles","value":"Seychelles","icon":"sc"},{"label":"Ras Al Khaimah (UAE)","value":"Ras Al Khaimah","icon":"ae"},{"label":"United Kingdom","value":"United Kingdom","icon":"gb"}]}}');
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./pages/offshore/articles/index.js




var __N_SSG = true;
function Home(_ref) {
  var data = _ref.data;
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(Layout/* default */.Z, {
      locationRouter: "offshore",
      page: data.page,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(articles/* default */.Z, {
        data: data_namespaceObject,
        posts: data === null || data === void 0 ? void 0 : data.posts
      })
    })
  });
}

/***/ }),

/***/ 76996:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/offshore/articles",
      function () {
        return __webpack_require__(48456);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3105,9593,9885,4090,9738,7447,2314,8675,9774,2888,179], function() { return __webpack_exec__(76996); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);